import { render, staticRenderFns } from "./ChannelListPage.vue?vue&type=template&id=167c1bcc&scoped=true"
import script from "./ChannelListPage.vue?vue&type=script&lang=js"
export * from "./ChannelListPage.vue?vue&type=script&lang=js"
import style0 from "./ChannelListPage.vue?vue&type=style&index=0&id=167c1bcc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167c1bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167c1bcc')) {
      api.createRecord('167c1bcc', component.options)
    } else {
      api.reload('167c1bcc', component.options)
    }
    module.hot.accept("./ChannelListPage.vue?vue&type=template&id=167c1bcc&scoped=true", function () {
      api.rerender('167c1bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channel/ChannelListPage.vue"
export default component.exports